export default {
  root: 'Carpetas Kimple',
  resourcesAmountTitle: '{n} Recurso | {n} Recursos',
  by: 'por Kimple',
  duration: 'Duración',
  sessions: 'Clases',
  resources: 'Recursos',
  subjects: 'Áreas cruzadas',
  ageRanges: 'Edades',
  sdg: 'ODS',
  sessionsAmount: '{n} Clase | {n} Clases',
  resourcesAmount: '{n} Recurso | {n} Recursos',
  agesAmount: '{n} Edad | {n} Edades',
  subjectsAmount: '{n} Área cruzada | {n} Áreas cruzadas',
  sdgAmount: '{n} ODS',
  agesTag: '{min} a {max} años',
  sdgDetails: 'Esta carpeta fomenta la consecución de los siguientes ODS',
  redirection: 'La carpeta no se encuentra en el idioma seleccionado, pero la puedes ver en ',
  and: 'y ',
  novelty: 'Novedad'
}

export const en = {
  root: 'Kimple Folders',
  resourcesAmountTitle: '{n} Resource | {n} Resources',
  by: 'by Kimple',
  duration: 'Duration',
  sessions: 'Classes',
  resources: 'Resources',
  subjects: 'Cross-sectional areas',
  ageRanges: 'Ages',
  sdg: 'SDG',
  sessionsAmount: '{n} Class | {n} Classes',
  resourcesAmount: '{n} Resource | {n} Resources',
  agesAmount: '{n} Age | {n} Ages',
  subjectsAmount: '{n} Cross area | {n} Cross areas',
  sdgAmount: '{n} SDG',
  agesTag: '{min} to {max} y/o',
  sdgDetails: 'This folder promotes the achievement of the following SDG\'s',
  redirection: 'The folder is not available in the selected language, but you can see it in ',
  and: 'and ',
  novelty: 'New'
}

export const ca = {
  root: 'Carpetes Kimple',
  resourcesAmountTitle: '{n} Recurs | {n} Recursos',
  by: 'per Kimple',
  duration: 'Durada',
  sessions: 'Clases',
  resources: 'Recursos',
  subjects: 'Àrees Creuades',
  ageRanges: 'Edats',
  sdg: 'ODS',
  sessionsAmount: '{n} Classe | {n} Classes',
  resourcesAmount: '{n} Recurs | {n} Recursos',
  agesAmount: '{n} Edat | {n} Edats',
  subjectsAmount: '{n} Àrea creuada | {n} Àrees Creuades',
  sdgAmount: '{n} ODS',
  agesTag: '{min} a {max} anys',
  sdgDetails: 'Aquest carpeta fomenta la consecució dels següents ODS',
  redirection: 'La carpeta no es troba en l\'idioma seleccionat, però la pots veure en ',
  and: 'y ',
  novelty: 'Novetat'
}
